<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-form
                    ref="form"
                    lazy-validation
                    @submit.prevent
                >
                    <v-row>
                        <v-col cols="12">
                            <v-radio-group
                                v-model="data['filters[type]']"
                                label="Tipo de fatura:"
                                row
                            >
                                <v-radio
                                    label="Avulsa"
                                    value="single"
                                ></v-radio>
                                <v-radio
                                    label="Mensalidade"
                                    value="monthly"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4">
                            <v-menu
                                ref="menuBillingAt"
                                v-model="menuBillingAt"
                                :close-on-content-click="false"
                                :return-value.sync="data['filters[billing_at]']"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        ref="billing_at_input"
                                        v-model="billing_at"
                                        label="Data da fatura"
                                        hint="Filtro por data da fatura selecione início e fim"
                                        placeholder="Data da fatura"
                                        required
                                        prepend-inner-icon="$calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="data['filters[billing_at]']"
                                    no-title
                                    scrollable
                                    range
                                    locale="pt-br"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuBillingAt.save(checkDate('billing_at'))"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                                ref="menuDueAt"
                                v-model="menuDueAt"
                                :close-on-content-click="false"
                                :return-value.sync="data['filters[due_at]']"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        ref="due_at_input"
                                        v-model="due_at"
                                        label="Data de vencimento"
                                        hint="Filtro por data de vencimento selecione início e fim"
                                        placeholder="Data de vencimento"
                                        required
                                        prepend-inner-icon="$calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="data['filters[due_at]']"
                                    no-title
                                    scrollable
                                    range
                                    locale="pt-br"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuDueAt.save(checkDate('due_at'))"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                                ref="menuPaidAt"
                                v-model="menuPaidAt"
                                :close-on-content-click="false"
                                :return-value.sync="data['filters[paid_at]']"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        ref="paid_at_input"
                                            v-model="paid_at"
                                        label="Data de pagamento"
                                        hint="Filtro por data de pagamento selecione início e fim"
                                        placeholder="Data de pagamento"
                                        required
                                        prepend-inner-icon="$calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="data['filters[paid_at]']"
                                    no-title
                                    scrollable
                                    range
                                    locale="pt-br"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menuPaidAt.save(checkDate('paid_at'))"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>


                </v-form>
            </v-col>

            <v-col
                cols="12"
                class="d-flex justify-end"
            >
                <cp-button
                    class="mr-md-2"
                    :disabled="isLoading"
                    :loading="isLoading"
                    left-icon="$close"
                    @click="clearFilter()"
                >
                    Limpar
                </cp-button>
                <cp-button
                    color="primary"
                    :disabled="isLoading"
                    :loading="isLoading"
                    left-icon="$filterOutline"
                    @click="submit()"
                >
                    Filtrar
                </cp-button>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import BaseModel from '@cp-models/BaseModel'
import { redirectClearingFilters } from '@utils/filters'

export default {
    props: {
        filters: {
            type: Object,
            required: true,
        },
        search: {
            type: String,
            default: null,
        },
    },

    data: () => ({
        isLoading: false,
        data: null,
        menuBillingAt: false,
        menuDueAt: false,
        menuPaidAt: false,
        model: new BaseModel,
    }),

    created() {
        this.fillData(this.filters)
    },

    methods: {
        submit() {
            this.clearData()

            this.isLoading = true
            this.redirect(this.route(this.currentRouteName, this.data))
        },

        fillData(filters = {}) {
            this.data = {
                'filters[type]': filters.type || null,
                'filters[billing_at]': filters.billing_at || null,
                'filters[due_at]': filters.due_at || null,
                'filters[paid_at]': filters.paid_at || null,
                'search': this.search,
            }
        },

        clearData() {
            this.data = {
                'filters[type]': this.data['filters[type]'] || null,
                'filters[billing_at]': this.data['filters[billing_at]'] || null,
                'filters[due_at]': this.data['filters[due_at]'] || null,
                'filters[paid_at]': this.data['filters[paid_at]'] || null,
                'search': this.search || null,
            }
        },

        clearFilter() {
            redirectClearingFilters(this)
        },

        checkDate(field) {
            if (this.data[`filters[${field}]`] && this.data[`filters[${field}]`][0] && !this.data[`filters[${field}]`][1]) {
                this.data[`filters[${field}]`][1] = this.data[`filters[${field}]`][0]
            }

            return this.data[`filters[${field}]`]
        },

        formatDateRange(field) {
            return this.data[field] && this.data[field][0] && this.data[field][1]
                ? this.model.formatDate(this.data[field][0], true) + ' - ' + this.model.formatDate(this.data[field][1], true)
                : ''
        },
    },

    computed: {
        billing_at: {
            get() {
                return this.formatDateRange('filters[billing_at]')
            },
            set(newDate) {
                this.data['filters[billing_at]'] = [newDate[0], newDate[1]]
            },
        },
        due_at: {
            get() {
                return this.formatDateRange('filters[due_at]')
            },
            set(newDate) {
                this.data['filters[due_at]'] = [newDate[0], newDate[1]]
            },
        },
        paid_at: {
            get() {
                return this.formatDateRange('filters[paid_at]')
            },
            set(newDate) {
                this.data['filters[paid_at]'] = [newDate[0], newDate[1]]
            },
        },
    },
}
</script>
